module.exports = __webpack_public_path__ + "static/media/clubs_10.264d8513.png";